import { day } from '@vrplatform/utils';

type RangeUnit = 'day' | 'month' | 'year';

export const getDatesBetweenRange = (
  start: string,
  end: string,
  opts?: {
    type: RangeUnit;
    inclusive?: boolean;
  }
) => {
  const type: RangeUnit = opts?.type ?? 'day';
  const inclusive = opts?.inclusive ?? false;

  let startDay = day(start);
  let endDay = day(end);

  if (startDay.isAfter(endDay)) {
    const temp = startDay;
    startDay = endDay;
    endDay = temp;
  }

  startDay = startDay.startOf(type);
  endDay = endDay.startOf(type);

  const exclusiveLimit = startDay.isSame(endDay, type)
    ? endDay.add(1, type)
    : endDay;
  const limit = inclusive ? endDay.add(1, type) : exclusiveLimit;

  const dates: string[] = [];
  let cursor = startDay;

  while (cursor.isBefore(limit, type)) {
    dates.push(cursor.yyyymmdd());
    cursor = cursor.add(1, type);
  }

  return dates;
};
